(() => {
  if (window.__uuOfferInstalled) return;
  window.__uuOfferInstalled = true;
  const money = (cents, widget) => {
    try { return new Intl.NumberFormat(widget.dataset.locale || 'en', {style:'currency', currency:widget.dataset.currency || 'GBP'}).format(cents / 100); }
    catch { return (cents / 100).toFixed(2); }
  };
  const refresh = (widget, variant) => {
    const form = widget.closest('form');
    if (!form) return;
    let prices;
    try { prices = JSON.parse(widget.querySelector('[data-uu-variants]').textContent); } catch { return; }
    const variantId = String(variant?.id || form.querySelector('input[name="id"]')?.value || '');
    const price = Number(prices[variantId]);
    if (!Number.isFinite(price)) return;
    for (const [tier, reduction] of [[1,0],[2,Number(widget.dataset.off2)],[3,Number(widget.dataset.off3)]]) {
      widget.querySelector('[data-uu-price="'+tier+'"]').textContent = money(Math.round(price * tier * (1 - reduction / 100)), widget);
    }
  };
  const apply = widget => {
    const form = widget.closest('form');
    const input = form?.querySelector('quantity-selector-component input[name="quantity"]');
    const choice = widget.querySelector('input[type="radio"]:checked');
    if (!input || !choice || input.disabled) return;
    const quantity = Number(choice.value);
    const min = Number(input.min || 1), max = Number(input.max || Infinity), step = Number(input.step || 1);
    if (quantity < min || quantity > max || (quantity - min) % step !== 0) {
      choice.checked = false;
      const matching = widget.querySelector('input[value="'+input.value+'"]');
      if (matching) matching.checked = true;
      return;
    }
    input.value = String(quantity);
    input.dispatchEvent(new Event('change', {bubbles:true}));
    input.dispatchEvent(new Event('input', {bubbles:true}));
  };
  document.addEventListener('change', event => {
    const radio = event.target.closest?.('[data-uu-offers] input[type="radio"]');
    if (radio) apply(radio.closest('[data-uu-offers]'));
  });
  document.addEventListener('variant:update', event => {
    document.querySelectorAll('[data-uu-offers]').forEach(widget => refresh(widget, event.detail?.variant));
  });
  document.addEventListener('quantity-selector:update', event => {
    const input = event.target?.closest?.('product-form-component')?.querySelector('quantity-selector-component input[name="quantity"]');
    if (!input) return;
    const widget = input.closest('product-form-component')?.querySelector('[data-uu-offers]');
    const matching = widget?.querySelector('input[type="radio"][value="'+input.value+'"]');
    if (matching) matching.checked = true;
  });
  const init = scope => scope.querySelectorAll('[data-uu-offers]').forEach(widget => refresh(widget));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();